import {Component, inject, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
// @ts-ignore
import {AppStore, ReloadDocumentListAction} from '@alfresco/aca-shared/store';
import {Store} from '@ngrx/store';
import {EditTextService} from "../../../../services/edit-text.service";

@Component({
  standalone: false,
  selector: 'app-edit-text-dialog',
  templateUrl: './edit-text-dialog.component.html',
})
export class EditTextDialogComponent implements OnInit {
  error: string = '';
  note: any;
  protected store = inject<Store<AppStore>>(Store<AppStore>);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EditTextDialogComponent>,
    private editTextService: EditTextService
  ) {
  }

  ngOnInit() {
    this.getNodeTxtContent(this.data.id);
  }

  onSubmit() {
    if (this.note) {
      this.editTextService.editText(this.note, this.data).subscribe(() => {
        this.store.dispatch(new ReloadDocumentListAction());
        this.dialogRef.close();
      });
    } else {
      this.error = 'Veuillez saisir une note.';
    }

  }

  getNodeTxtContent(nodeId: string) {
    this.editTextService.getTxtFileContent(nodeId).subscribe(
      (content: string) => {
        this.note = content;
      },
      error => {
        console.error('Erreur lors de la récupération du contenu du fichier texte :', error);
      }
    );
  }
}
